import React from 'react'
import { NavLink, useLocation } from 'react-router-dom'

const ATTENDANCE_NAV_TABS = [
  { id: 'daily', label: 'Daily Attendance', path: '/attendance/daily' },
  { id: 'monthly', label: 'Monthly Attendance', path: '/attendance/monthly' },
  { id: 'biometric', label: 'Biometric Records', path: '/attendance/biometric' },
  { id: 'upload-swipes', label: 'Upload Swipes', path: '/attendance/upload-swipes' },
  { id: 'settings', label: 'Settings', path: '/attendance/settings' },
]

export default function AttendanceSubNav() {
  const location = useLocation()

  function isTabActive(tab) {
    if (tab.id === 'daily') {
      return (
        location.pathname.startsWith('/attendance/daily') ||
        location.pathname === '/attendance'
      )
    }
    return location.pathname.startsWith(`/attendance/${tab.id}`)
  }

  return (
    <nav
      className="flex max-w-full shrink-0 items-center gap-1.5 overflow-x-auto rounded-2xl bg-surface-container-low p-1.5 app-hide-scrollbar"
      aria-label="Attendance Navigation Tabs"
    >
      {ATTENDANCE_NAV_TABS.map((tab) => {
        const active = isTabActive(tab)
        return (
          <NavLink
            key={tab.id}
            to={tab.path}
            className={`whitespace-nowrap rounded-xl px-4 py-2 text-xs font-bold transition-all ${
              active
                ? 'bg-surface-container-lowest text-primary shadow-sm ring-1 ring-primary/10'
                : 'text-on-surface-variant hover:bg-surface-container-high/60 hover:text-on-surface'
            }`}
          >
            <span>{tab.label}</span>
          </NavLink>
        )
      })}
    </nav>
  )
}
